import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { AccessRange, KeyValues5, KeyValueSet, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-add-access',
  templateUrl: './add-access.component.html',
  styleUrls: ['./add-access.component.scss']
})
export class AddAccessComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["access"]; accessTypes: KeyValueSet[]; accessRanges: KeyValueSet[];
  data: KeyValues5; ctryCode: string; userId: string; message: string = ''; isRedAlert: boolean = true;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, public profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.data = { key: this.userId, v1: this.ctryCode, v2: '', v3: '', v4: '', v5: '' } as KeyValues5;
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.profileManagementService.saveUserAccess(this.data).subscribe(result => {

        switch (result.status) {
          case Status.Success: {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          } break;
          case Status.EmailRequired: {
            this.message = this.localService.languageContent.access.email_required;
          } break;
        }
      });
    }
  }

  onAccessRangeSelect() {
    this.data.v4 = '';
  }

  onLocationSelected(location: KeyValues5) {
    this.data.v3 = location.key;
    this.data.v4 = '';
    switch (parseInt(this.data.v2)) {
      case AccessRange.Country: {
        this.data.v4 = location.v1;
      } break;
      case AccessRange.State: {
        this.data.v4 = location.v2;
      } break;
      case AccessRange.District: {
        this.data.v4 = location.v3;
      } break;
      case AccessRange.Constituency: {
        this.data.v4 = location.v4;
      } break;
    }
  }

  doCheck() {
    let message = '';
    if (this.data.v5 == '') {
      message = this.localService.languageContent.access.access_type_empty;
    } else if (this.data.v2 == '') {
      message = this.localService.languageContent.access.access_range_empty;
    } else if (this.data.v2 != '' && parseInt(this.data.v2) != AccessRange.Global && this.data.v4 == '') {
      message = this.localService.languageContent.access.access_range_location_empty;
    }
    this.message = message;
    return message == '';
  }
}
